import PropTypes from 'prop-types';
import React from 'react';

import { Box } from '@material-ui/core';
import {
  SectionAboutLeasing,
} from '@product-site-frontend/gatsby-theme-blocks';
import {
  SectionBlog,
  SectionBusinessSegments,
  SectionMainImgArray,
  SectionPartners,
} from '@product-site-frontend/landing';
import {
  SectionConsultation,
  SectionHowToGetFinancing,
  SectionLeasingAdvantages,
  SectionLeasingScheme,
} from '@product-site-frontend/shared';
import { graphql } from 'gatsby';

// import SectionBlog from '../components/SectionBlog';
// import SectionMain from '../components/SectionMain';
// import SectionPartners from '../components/SectionPartners';
import Seo from '../components/Seo';

IndexPage.propTypes = {
  data: PropTypes.shape({
    aboutLeasingContent: PropTypes.object,
    businessSegmentsContent: PropTypes.object,
    leasingAdvantagesContent: PropTypes.object,
    leasingSchemeContent: PropTypes.object,
    mainSectionContent: PropTypes.object,
    partners: PropTypes.object,
    home: PropTypes.object,
    articles: PropTypes.object,
    financingContent: PropTypes.object,
  }),
  pageContext: PropTypes.shape({
    regionContent: PropTypes.object,
  }),
};

export default function IndexPage({ data, pageContext }) {
  const {
    aboutLeasingContent,
    articles,
    businessSegmentsContent,
    financingContent,
    home,
    leasingAdvantagesContent,
    leasingSchemeContent,
    partners,
  } = data;

  const { regionContent } = pageContext;

  return (
    <Box>
      <Seo pageData={regionContent.seo} />
      <SectionMainImgArray content={{ ...home.main, title: regionContent.title }} />
      <SectionAboutLeasing content={aboutLeasingContent} />
      <SectionBusinessSegments content={businessSegmentsContent} />
      <SectionLeasingScheme content={leasingSchemeContent} />
      <SectionLeasingAdvantages content={leasingAdvantagesContent} />
      <SectionHowToGetFinancing content={financingContent} />
      <SectionBlog articles={articles.nodes} />
      <SectionPartners content={home.partners} partners={partners.nodes} />
      <SectionConsultation />
    </Box>
  );
}

export const query = graphql`
  query IndexPageQuery {
    home: strapiHome {
      seo {
        title
        description
        meta {
          content
          name
        }
      }
      main {
        title
        description
        term
        dealAmount
        dealPercent
        advanceRate
        bgDesktop {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
        }
        calculatorRate
      }
      partners {
        title
        cards {
          id
          alternativeText
          caption
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
    aboutLeasingContent: strapiAboutLeasing {
      title
      description
      cards {
        text
        image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
        }
      }
    }
    businessSegmentsContent: strapiBusinessSegments {
      title
      description
      cards {
        text
        image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 512)
            }
          }
        }
      }
    }
    leasingSchemeContent: strapiLeasingScheme {
      title
      caption
      steps {
        title
        description
      }
    }
    leasingAdvantagesContent: strapiLeasingAdvantages {
      cards {
        title
        description
        icon {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
        }
      }
      title
    }
    financingContent: strapiFinancing {
      title
      steps {
        title
        description
      }
      description
      bgDesktop {
        localFile {
          childImageSharp {
            gatsbyImageData(width: 500, placeholder: NONE)
          }
        }
      }
    }
    partners: allStrapiPartners(sort: { fields: order }) {
      nodes {
        name
        order
        url
        logo {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
            }
          }
        }
      }
    }
    articles: allStrapiArticles(sort: { order: DESC, fields: strapiId }) {
      nodes {
        strapiId
        publishedAt
        slug
        title
        description
        image {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
